var BD = typeof BD === 'object' ? BD : {};

BD.Item = {};
BD.Item.Stock = {};
BD.Item.Stock.Info = {};
BD.Item.Stock.Info.Get = function() {
	//console.log("EXECUTED: BD.Item.Stock.Info.Get");
	// Hide Stock Info Banners
	document.getElementById("stock_info_unavailable_banner").classList.add("d-none");
	document.getElementById("stock_info_limited_banner").classList.add("d-none");
	document.getElementById("stock_info_low_banner").classList.add("d-none");
	document.getElementById("stock_info_available_banner").classList.add("d-none");

	// Check if product sku element exist, on success attempt to retrieve remote stock info
	// .t5 .no-js-hidden
	if (document.querySelector('.product__sku')) {
		//console.log("SKU FOUND!!!");
		let lookup_sku = document.querySelector('.product__sku').textContent;

		let item_msg = [];
		let item_sku = "";
		let item_qty = "";
		let item_esd = "";

		let data = new FormData();
		data.append("selected_action", "stock_level");
		data.append("sku", lookup_sku);

		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				try {
					let result = JSON.parse(xhr.responseText);
					//console.log(result);

					if (result.item_sku) {
						item_sku = result.item_sku;
						item_qty = Number(result.item_qty);
						item_esd = result.item_esd;

						// Stock Unavailable Banner
						if (item_qty === 0) {
							document.getElementById("stock_info_unavailable_banner").classList.remove("d-none");

							if (item_esd.length === 0) {
								document.getElementById("stock_info_unavailable_esd").classList.add("d-none");
							} else {
								document.getElementById("stock_info_unavailable_esd").classList.remove("d-none");
								document.getElementById("stock_info_unavailable_esd").innerHTML = item_esd;
							}

						}
						// Stock Limited Banner
						else if (item_qty <= 2) {
							document.getElementById("stock_info_limited_banner").classList.remove("d-none");
							document.getElementById("stock_info_limited_qty").innerHTML = item_qty;
							document.getElementById("stock_info_limited_esd").innerHTML = item_esd;
						}
						// Stock Low Banner
						else if (item_qty < 10) {
							document.getElementById("stock_info_low_banner").classList.remove("d-none");
							document.getElementById("stock_info_low_qty").innerHTML = item_qty;
							document.getElementById("stock_info_low_esd").innerHTML = item_esd;
						}
						// Stock Available Banner
						else {
							document.getElementById("stock_info_available_banner").classList.remove("d-none");
							document.getElementById("stock_info_available_qty").innerHTML = item_qty;
							document.getElementById("stock_info_available_esd").innerHTML = item_esd;
						}
					}
				} catch (err) {
					console.log(err.message + " in " + xhr.responseText);
				}
			}
		};
		xhr.open("POST", "https://shopify.bddiesel.com/php/shopify.xhr.stock.level.php");
		xhr.send(data);
	}
};
BD.Item.Stock.Info.Observe = function() {
	const targetNode = document.querySelector('.product__sku');

	// Check if product sku element exist, on success create MutationObserver
	if (targetNode) {
		// Define the callback function that will run when a mutation is detected
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'characterData' || mutation.type === 'childList') {
					const newSku = targetNode.textContent.trim();
					console.log(`The SKU has changed to: ${newSku}`);
					BD.Item.Stock.Info.Get();
					return;
				}
			}
		};

		// Create a new MutationObserver instance and pass it the callback function
		const observer = new MutationObserver(mutationCallback);

		// Configure the observer to watch for the specific changes
		const config = {
			childList: true,
			characterData: true,
			subtree: true
		};

		// Start observing the target node with the specified configuration
		observer.observe(targetNode, config);

		//console.log('Observer is now watching the SKU element for changes.');

	} else {
		//console.error('Could not find the element with selector ".product__sku .t5 .no-js-hidden" to observe.');
	}
};

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", function() {
	BD.Item.Stock.Info.Get();
	BD.Item.Stock.Info.Observe();
}, false);
